const ACTIVE_AUTH_MODE_KEY = "shopbook.auth.active-mode";

export function readActiveAuthMode() {
  try {
    const value = localStorage.getItem(ACTIVE_AUTH_MODE_KEY);
    return value === "independent" ? value : null;
  } catch {
    return null;
  }
}

export function writeActiveAuthMode(mode) {
  try {
    localStorage.setItem(ACTIVE_AUTH_MODE_KEY, mode);
  } catch {
    // Ignore storage failures in private/incognito contexts.
  }
}

export function clearActiveAuthMode() {
  try {
    localStorage.removeItem(ACTIVE_AUTH_MODE_KEY);
  } catch {
    // Ignore storage failures in private/incognito contexts.
  }
}
